import React from "react";
import {
  Box,
  Flex,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  HStack,
  Button,
  VStack,
  MenuIcon,
  ListIcon,
  Collapse,
  useToast,
} from "@chakra-ui/react";
import Sidebar from "../Components/Sidebar";
import TopNavbar from "../Components/TopNavbar";
import MobileHandler from "../Components/MobileHandler";
import WarningBar from "../Components/WarningBar";
import { useDispatch, useSelector } from "react-redux";
import { getglobalStoreObject, setState } from "../Stores/globalStore";
import ProfileVisualizer from "../Components/ProfileVisualizer";
import {
  getDocument,
  setApiKey,
  setProjectId,
  updateDocument,
} from "../Repos/Sanity";
import { useParams, Redirect, useNavigate } from "react-router-dom";
import SymbolData from "../Components/SymbolData";
import {
  GetPriceAverages,
  LoadAverages,
  getOrganizedPriceArray,
  removeUntilKeyFound,
} from "../Repos/StocksCalculations";
import { compareDates, formatDate, sortByEarningsDate } from "../Repos/Utils";

function Dashboard() {
  const toast = useToast();
  const params = useParams();
  const navigate = useNavigate();
  // console.log("dashboard params ", params);

  const globalStore = useSelector(getglobalStoreObject);
  const _dispatch = useDispatch();

  //const [isMobile, setIsMobile] = React.useState(false);
  const [leftSideIsOpen, setleftSideIsOpen] = React.useState(
    !globalStore.isMobile
  );
  const [rightSideIsOpen, setrightSideIsOpen] = React.useState(
    !globalStore.isMobile
  );

  const [allItems, setallItems] = React.useState([]);
  const [foundSymbols, setfoundSymbols] = React.useState([]);
  const [centerData, setcenterData] = React.useState([]);

  const [activeSymbol, setactiveSymbol] = React.useState({ symbol: "base" });

  const getSettings = () => {
    try {
      //download every item of type setting
      getDocument({ _type: "setting" }, (_settings) => {
        _dispatch(
          setState({
            settings: {
              support_email: _settings.filter(
                (p) => p.key == "support_email"
              )[0].value,
              price_1_year: _settings.filter((p) => p.key == "price_1_year")[0]
                .value,
              price_1_month: _settings.filter(
                (p) => p.key == "price_1_month"
              )[0].value,
              api_key: _settings.filter((p) => p.key == "api_key")[0].value,
            },
          })
        );
      });
    } catch (error) {
      console.log("error in getSettings: ", error);
    }
  };
  const onLoad = () => {
    //get every symbol name

    getSettings();
    getDocument(
      { _type: "symbolData" },
      (_symbols) => {
        // console.log("profiles ", _profiles.length);
        // console.log("data found ", _symbols);
        if (_symbols.length < 1) {
          navigate("/notFound");
        }

        //load only the symbols that are present in the profile
        _symbols = _symbols.filter((_s) => {
          var isValidSymbol = false;
          isValidSymbol = globalStore.user_profile.menuSymbols.includes(
            _s.symbol
          );
          return isValidSymbol;
        });

        //if we are not premium users
        //load only the first 2 documents
        if (
          compareDates(
            formatDate(new Date()),
            globalStore.user_profile.expireDate
          )
        ) {
          //if we are not premium
          _symbols = _symbols.slice(0, 2);
        }

        _symbols.forEach((_s) => {
          // console.log("loading averages for ", _s.symbol);
          // console.log(
          //   "does state for " + _s.symbol + " exists?",
          //   !!globalStore[_s.symbol],
          //   "shall i load? ",
          //   !!!globalStore[_s.symbol]
          // );
          if (!!!globalStore[_s.symbol]) {
            LoadAverages(_s, (newState) => {
              _dispatch(setState({ ...newState }));
            });
          }
        });

        setfoundSymbols(_symbols);
        //do the different loadings here

        _dispatch(
          setState({
            // profile: json.profile,
            centerNavigation: "symbols",
            isLoading: false,
          })
        );
      },
      ["symbol", "earningsDate"]
    );
  };

  React.useEffect(() => {
    // console.log("testing params", params);
    _dispatch(
      setState({
        isLoading: true,
      })
    );

    //only when we open this screen, and there is a profile loaded, we can visualize everything
    if (!!!globalStore.user_profile) {
      navigate("/login");
      return;
    }

    document.title = "Stock Inquiry";

    onLoad();
  }, []);

  React.useEffect(() => {
    setfoundSymbols((foundSymbols) =>
      foundSymbols.map((item) => ({
        ...item,
        loaded: !!globalStore[item.symbol], // true only for the clicked one, false for all others
        volatility: (globalStore[item.symbol] ?? { volatility: 0 }).volatility,
        performance: (globalStore[item.symbol] ?? { performance: 0 })
          .performance,
        overpricing: (globalStore[item.symbol] ?? { overpricing: 0 })
          .overpricing,
        fcfYield: (
          globalStore[item.symbol] ?? { financialData: { fcfYield: 0 } }
        ).financialData.fcfYield,
        ocfYield: (
          (globalStore[item.symbol] ?? { financialData: { ocfYield: 0 } })
            .financialData.ocfYield ?? 0
        ).toFixed(2),
      }))
    );
  }, [globalStore]);

  //update foundsymbols with the color of my symbol being green

  return (
    <Box minH="100vh">
      {!!globalStore.user_profile ? (
        <TopNavbar
          onProfileClick={() => {
            _dispatch(setState({ centerNavigation: "profile" }));
          }}
          onLeftSideOpen={() => {
            setleftSideIsOpen(true);
          }}
        />
      ) : (
        <></>
      )}

      {/* main content area */}
      <Flex h="89vh">
        <MobileHandler
          direction="left"
          isOpen={leftSideIsOpen}
          isMobile={globalStore.isMobile}
          onClose={() => {
            setleftSideIsOpen(false);
          }}
        >
          <Sidebar
            onClick={(_symbol) => {
              setactiveSymbol(_symbol);
              setfoundSymbols((foundSymbols) =>
                foundSymbols.map((item) => ({
                  ...item,
                  selected: item.symbol === _symbol.symbol, // true only for the clicked one, false for all others
                }))
              );

              setleftSideIsOpen(false);
              _dispatch(setState({ centerNavigation: "symbols" }));
            }}
            paths={foundSymbols}
            onNewSymbolCreated={(newSymbol) => {
              // console.log("onnew symbol created");
              LoadAverages(newSymbol, (newState) => {
                // update locally
                const newSymbolsArray = foundSymbols.concat({
                  symbol: newSymbol.symbol,
                  earningsDate: newSymbol.earningsDate,
                  loaded: true,
                });
                setfoundSymbols(newSymbolsArray);
                // update On Db

                const newUserProfileSymbols = newSymbolsArray.map(
                  (_p) => _p.symbol
                );
                const newUserProfile = {
                  ...globalStore.user_profile,
                  menuSymbols: newUserProfileSymbols,
                };
                _dispatch(
                  setState({ ...newState, user_profile: newUserProfile })
                );
                updateDocument(newUserProfile, () => {
                  toast({
                    title: "profile updated!",
                    description: "symbol added to the user",
                    status: "success",
                    duration: 9000,
                    isClosable: true,
                  });
                });
              });
            }}
            onSymbolDelete={(_s) => {
              console.log(
                "new symbols array before delete ",
                foundSymbols.length
              );
              const newSymbolsArray = foundSymbols.filter(
                (_p) => _p.symbol != _s.symbol
              );
              console.log(
                "new symbols array after delete ",
                newSymbolsArray.length
              );
              //update locally
              setfoundSymbols(newSymbolsArray);
              // update on db
              const newUserProfileSymbols = newSymbolsArray.map(
                (_p) => _p.symbol
              );
              const newUserProfile = {
                ...globalStore.user_profile,
                menuSymbols: newUserProfileSymbols,
              };
              _dispatch(setState({ user_profile: newUserProfile }));
              updateDocument(newUserProfile, () => {
                toast({
                  title: "remove confirmed!",
                  description: "symbol removed from the user",
                  status: "success",
                  duration: 9000,
                  isClosable: true,
                });
              });
            }}
            onChangeFoundSymbolSorting={(_sort) => {
              if (_sort == 0) {
                // console.log("sorting type 0");
                var sortedSymbols = [...foundSymbols];
                sortedSymbols.sort((a, b) => a.symbol.localeCompare(b.symbol));
                setfoundSymbols(sortedSymbols);
              }
              if (_sort == 1) {
                // console.log("sorting type 1");
                var sortedSymbols = [...foundSymbols];
                // console.log("beforevol sort", sortedSymbols);
                sortedSymbols.sort((a, b) => b.volatility - a.volatility);
                // console.log("after vol sort", sortedSymbols);
                setfoundSymbols(sortedSymbols);
              }
              if (_sort == 2) {
                // console.log("sorting type 2");
                var sortedSymbols = [...foundSymbols];
                // console.log("beforevol sort", sortedSymbols);
                sortByEarningsDate(sortedSymbols);
                // console.log("after vol sort", sortedSymbols);
                setfoundSymbols(sortedSymbols);
              }
              if (_sort == 3) {
                // console.log("sorting type 1");
                var sortedSymbols = [...foundSymbols];
                // console.log("beforevol sort", sortedSymbols);
                sortedSymbols.sort((a, b) => a.performance - b.performance);
                // console.log("after vol sort", sortedSymbols);
                setfoundSymbols(sortedSymbols);
              }
              if (_sort == 4) {
                // console.log("sorting type 1");
                var sortedSymbols = [...foundSymbols];
                // console.log("beforevol sort", sortedSymbols);
                sortedSymbols.sort((a, b) => a.overpricing - b.overpricing);
                // console.log("after vol sort", sortedSymbols);
                setfoundSymbols(sortedSymbols);
              }
              if (_sort == 5) {
                // console.log("sorting type 1");
                var sortedSymbols = [...foundSymbols];
                // console.log("beforevol sort", sortedSymbols);
                sortedSymbols.sort((a, b) => b.ocfYield - a.ocfYield);
                // console.log("after vol sort", sortedSymbols);
                setfoundSymbols(sortedSymbols);
              }
            }}
          ></Sidebar>
        </MobileHandler>

        {globalStore.centerNavigation == "profile" ? (
          <ProfileVisualizer></ProfileVisualizer>
        ) : (
          <></>
        )}
        {globalStore.centerNavigation == "symbols" ? (
          <SymbolData
            key={
              activeSymbol.symbol +
              (globalStore[activeSymbol.symbol] ?? { lastRefresh: "" })
                .lastRefresh
            }
            // {...((globalStore.pageData ?? {})[activeSymbol.symbol] ?? {})}
            {...(globalStore[activeSymbol.symbol] ?? {})}
            onPastDateInput={(_pastDate) => {
              LoadAverages(
                activeSymbol,
                (newState) => {
                  newState["backup" + activeSymbol.symbol] = {
                    ...globalStore[activeSymbol.symbol],
                  };

                  _dispatch(setState({ ...newState }));
                },
                _pastDate
              );
            }}
            resetVisible={!!globalStore["backup" + activeSymbol.symbol]}
            onResetState={() => {
              var newState = {};
              newState[activeSymbol.symbol] = {
                ...globalStore["backup" + activeSymbol.symbol],
              };
              newState["backup" + activeSymbol.symbol] = undefined;

              _dispatch(setState({ ...newState }));
            }}
          ></SymbolData>
        ) : (
          <></>
        )}
      </Flex>
    </Box>
  );
}

export default Dashboard;
